import {Observable} from 'rxjs';
import {SmartLoaderService} from './../../../core/services/smart-loader.service';
import {AfterViewInit, Component, ComponentFactoryResolver, OnInit, ViewChild} from '@angular/core';

import {RxComponent} from './../../../core/components/common/rx.component';
import {ModalSize, SmartModalService} from './../../../core/services/smart-modal.service';
import {ComponentDirective} from './component.directive';

declare var $: any;

@Component({
    selector: '[itpx-modal]',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent extends RxComponent implements OnInit, AfterViewInit {

    private ModalSize = ModalSize;

    private loading: Observable<any>;

    private open: boolean;
    private title: string;
    private subtitle: string;
    private size: any;
    private position: string;
    private closable: boolean;

    @ViewChild(ComponentDirective) componentHost: ComponentDirective;

    constructor(
        private service: SmartModalService,
        private loadingService: SmartLoaderService,
        private componentFactoryResolver: ComponentFactoryResolver
    ) {
        super();
    }

    ngOnInit() {
        this.service.onModalOpen()
            .bindToLifecycle(this)
            .subscribe(event => {
                this.title = event.title;
                this.subtitle = event.subtitle;
                this.size = event.size;
                this.position = event.position;
                this.closable = event.closable;
                let componentFactory = this.componentFactoryResolver.resolveComponentFactory(event.component);
                let viewContainerRef = this.componentHost.viewContainerRef;
                viewContainerRef.clear();

                let componentRef = viewContainerRef.createComponent(componentFactory);

                let component = <Component>componentRef.instance;
                (component as any).data = event.data;
                this.show();
            });

        this.loading = this.loadingService.loading()
            .map(_ => ({loading: _}));

        this.service.onModalClose()
            .bindToLifecycle(this)
            .subscribe(_ => this.hide());
    }

    ngAfterViewInit() {
         $('#myModal').on('hide.bs.modal', () => {
            this.componentHost.viewContainerRef.clear();
            this.service.sendResult(null);
        });
    }

    private show() {
        $('#myModal') .modal('show')
    }

    private hide() {
        $('#myModal').modal('hide');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.ts